import React, { useRef, useEffect, useMemo } from 'react';
import { Canvas, useFrame } from '@react-three/fiber';
import * as THREE from 'three';
import { gsap } from 'gsap';

function FloatingCoin({ position }) {
  const meshRef = useRef();
  const rotationSpeed = Math.random() * 0.01 + 0.005;
  const floatSpeed = Math.random() * 0.001 + 0.001;
  const gsapInstance = useRef(null);

  useFrame((state) => {
    if (meshRef.current) {
      meshRef.current.rotation.y += rotationSpeed;
      meshRef.current.position.y = position[1] + Math.sin(state.clock.elapsedTime) * 0.3;
    }
  });

  useEffect(() => {
    if (meshRef.current) {
      gsapInstance.current = gsap.to(meshRef.current.scale, {
        x: 1.2,
        y: 1.2,
        z: 1.2,
        duration: 1,
        repeat: -1,
        yoyo: true,
        ease: "power1.inOut"
      });
    }

    return () => {
      if (gsapInstance.current) {
        gsapInstance.current.kill();
      }
    };
  }, []);

  return (
    <mesh ref={meshRef} position={position}>
      <cylinderGeometry args={[1, 1, 0.2, 32]} />
      <meshStandardMaterial 
        color="#C5B358"
        metalness={0.8}
        roughness={0.2}
        emissive="#C5B358"
        emissiveIntensity={0.2}
      />
    </mesh>
  );
}

function AnimatedBackground() {
  const coins = useMemo(() => Array(15).fill().map((_, i) => ({
    position: [
      Math.random() * 40 - 20,
      Math.random() * 20 - 10,
      Math.random() * 10 - 15
    ]
  })), []);

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', zIndex: -1 }}>
      <Canvas camera={{ position: [0, 0, 20], fov: 60 }}>
        <ambientLight intensity={0.5} />
        <pointLight position={[10, 10, 10]} intensity={1} />
        <fog attach="fog" args={['#0B4619', 15, 25]} />
        {coins.map((coin, i) => (
          <FloatingCoin key={i} position={coin.position} />
        ))}
      </Canvas>
    </div>
  );
}

export default AnimatedBackground;
